const TreatmentContent = () => {
    return (
        <>
            <h4>
                A successful new treatment approach for early breast cancer
            </h4>
            <p>
                A successful new treatment approach for early breast cancer, using tamoxifen therapy first and then switching to the aromatase-inhibitor drug exemestane in sequence, instead of the standard continuous tamoxifen, is reported in The New England Journal of Medicine in 2004. The Intergroup Exemestane Study (IES) paper concluded that switching to exemestane therapy for 2-3 years after the initial 2-3 years of tamoxifen results in a significant improvement in both disease-free survival and a significant reduction of new breast cancers in the opposite breast, when compared with the standard five years of continuous tamoxifen treatment. Longer term data, reported in 2009 after 91 months of follow up demonstrated a significant survival benefit for patients who were switched to exemestane compared to those who stayed on tamoxifen. 
            </p>
        </>
    );
}

export default TreatmentContent;